import { MenuState } from "./menuTypes";

export const initialState: MenuState = {
  menu: [],
  loading: false,
};
